import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import { environment } from './environments/environment';
import { oauthRedirectState$ } from './app/core/state/oauth-redirect.state';

// Registered before Amplify.configure() so we never miss the
// signInWithRedirect result if it resolves before the callback
// route/component has finished loading.
Hub.listen('auth', ({ payload }) => {
  if (payload.event === 'signInWithRedirect') {
    oauthRedirectState$.next({ status: 'success' });
  }
  if (payload.event === 'signInWithRedirect_failure') {
    oauthRedirectState$.next({ status: 'error', message: 'Login error' });
  }
});

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolClientId,
      loginWith: {
        oauth: {
          domain: environment.cognito.domain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [environment.cognito.redirectSignIn],
          redirectSignOut: [environment.cognito.redirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
